import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Base directive that exposes a shared Subject for components requiring
 * deterministic tear down of subscriptions on destroy.
 */
@Directive()
export class UnSubscribeComponent implements OnDestroy {
  unSubscribeOnDestroy: Subject<boolean> = new Subject();

  constructor() {}

  ngOnDestroy(): void {
    this.unSubscribeOnDestroy.next(true);
    this.unSubscribeOnDestroy.complete();
  }
}
